import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import { AuthContext } from '../../../@jumbo/components/context/AuthContext';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSnackbar } from 'notistack';

import { Box, MenuItem } from '@mui/material';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },

  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    marginTop: 20,
    borderRadius: 25,
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const OptionAddEdit = ({
  list,
  setList,
  editObj,
  setEditObj,
  editIndexNo,
  refresh,
  setRefresh,
  closeAddDialog,
  addDialog,
  allCountry,
  methodId,
  country_id,
}) => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const [id, setId] = useState('');
  const [countryId, setCountryId] = useState('');
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [sendAllowed, setSendAllowed] = useState('');
  const [receiveAllowed, setReceiveAllowed] = useState('');
  const [active, setActive] = useState('');
  const [mfsList, setMfsList] = useState([]);
  const [optionId, setOptionId] = useState('');

  const [loading, setLoading] = useState(false);
  const [addForm, setAddForm] = useState(true);
  const [editForm, setEditForm] = useState(false);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const clearStates = () => {
    setName('');
    setCode('');
    setCountryId();
    setOptionId();
    setSendAllowed('');
    setReceiveAllowed('');
    setActive('');
    setEditObj({});
  };

  // const getMfsList = async () => {
  //   setLoading(true);

  //   await axios
  //     .get(`/api/v1/public/mfs`)
  //     .then(function(response) {
  //       setMfsList(response?.data.data);
  //     })
  //     .catch(function(error) {
  //       // handle error
  //       console.log(error);
  //       // setMessage(error.response.data.error);
  //     });
  //   setLoading(false);
  // };

  const getMfsList = async cId => {
    setLoading(true);
    await axios
      .get(`/api/v1/private/country/${cId}/mfs`)
      .then(function(response) {
        console.log('mfs response', response);
        setMfsList(response.data.data);
        if (response.data.data.length < 1) {
          handleSnakbarOpen('No data found in the selected country', 'error');
        }
      })
      .catch(function(error) {
        // handle error
        // console.log(error);
        // setMessage(error.response.data.error);
        handleSnakbarOpen(error.response.data.error.toString(), 'error');
      });
    setLoading(false);
  };

  const handleCountry = e => {
    setCountryId(e.target.value);
    getMfsList(e.target.value);
  };

  const handleSubmit = async e => {
    console.log('editIndexNo', editIndexNo);
    e.preventDefault();

    setLoading(true);
    let response;
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);
    // {
    //   //   "code": "nagad",
    //   //   "name": "Nagad",
    //     "countryId" : "a5415985-7e67-43ba-be80-2126f1ed513a",
    //     "methodId" : "de07d9e4-11ee-48e4-9a20-37ee5236f392",
    //     "optionId": "7b5bae56-a5dd-4fc5-b653-b1059756cdad",
    //     "sendAllowed": false,
    //     "receiveAllowed": true,
    //     "active": true
    //   }
    let formData = {
      methodId,
      countryId,
      optionId,

      sendAllowed,
      receiveAllowed,
      active,
    };
    // return console.log('data', formData);
    try {
      if (addForm) {
        response = await axios({
          url: `/api/v1/private/transaction/transaction-option`,
          method: 'post',
          data: formData,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setList([...list, response.data.data]);

        setRefresh(!refresh);
        clearStates();
      } else if (editForm) {
        response = await axios({
          url: `/api/v1/private/transaction/transaction-option`,
          method: 'put',
          data: formData,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        console.log('editForm response', response);

        list[editIndexNo] = response.data.data;
        setRefresh(!refresh);
      }

      closeAddDialog();
      activeAddForm();
      handleSnakbarOpen(response.data.message, 'success');
    } catch (error) {
      handleSnakbarOpen(error.response.data.errors.toString(), 'error');
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    console.log('edit', editObj.id);
    if (editObj.id) {
      setAddForm(false);
      setEditForm(true);
      setId(editObj.id);
      setCode(editObj.code);
      setName(editObj.name);
      setSendAllowed(editObj.sendAllowed);
      setReceiveAllowed(editObj.receiveAllowed);
      setActive(editObj.active);
      setCountryId(country_id);
    }
  }, [editObj]);

  const activeAddForm = () => {
    clearStates();

    // setEditForm(false);
    // setAddForm(true);
  };
  useEffect(() => {
    if (addDialog === false) {
      activeAddForm();
    }
  }, [addDialog]);

  return (
    <React.Fragment>
      {/* <div className={classes.titleDiv}>
        {editForm && (
          <div className={classes.iconDiv}>
            <IconButton aria-label="close" color="inherit" size="small" onClick={activeAddForm}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </div>
        )}
        <Typography variant="h4" className={`${classes.marginStyle} ${classes.alignCenter}`}>
          {editForm ? 'Update Bank' : 'Add Bank'}
        </Typography>
      </div> */}
      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
              activeAddForm();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          {editForm ? 'Update transaction option' : 'Add transaction option'}
        </Typography>
      </div>
      <form onSubmit={handleSubmit}>
        <TextField
          variant="outlined"
          select
          label="Country"
          size="small"
          fullWidth
          required
          value={countryId}
          onChange={handleCountry}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          {allCountry.map((item, index) => (
            <MenuItem value={item.id} key={index}>
              <Box className={classes.inner}>
                <img src={item.flag} style={{ maxWidth: 24, marginRight: 10 }} alt="" /> {item.name}
              </Box>
            </MenuItem>
          ))}
        </TextField>
        <TextField
          variant="outlined"
          select
          label="MFS"
          size="small"
          fullWidth
          required
          value={optionId}
          onChange={e => setOptionId(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          {mfsList.map((item, index) => (
            <MenuItem value={item.id}>
              <Box className={classes.inner}>{item.name}</Box>
            </MenuItem>
          ))}
        </TextField>
        {/* <TextField
          label="Name"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={name}
          onChange={e => setName(e.target.value)}
        />
        <TextField
          label="Code"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={code}
          onChange={e => setCode(e.target.value)}
        /> */}
        <TextField
          variant="outlined"
          select
          label="Send Allowed"
          size="small"
          fullWidth
          required
          value={sendAllowed}
          onChange={e => setSendAllowed(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          <MenuItem value={true}>
            <Box className={classes.inner}>Yes</Box>
          </MenuItem>
          <MenuItem value={false}>
            <Box className={classes.inner}>No</Box>
          </MenuItem>
        </TextField>
        <TextField
          variant="outlined"
          select
          label="Receive Allowed"
          size="small"
          fullWidth
          required
          value={receiveAllowed}
          onChange={e => setReceiveAllowed(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          <MenuItem value={true}>
            <Box className={classes.inner}>Yes</Box>
          </MenuItem>
          <MenuItem value={false}>
            <Box className={classes.inner}>No</Box>
          </MenuItem>
        </TextField>
        <TextField
          variant="outlined"
          select
          label="Active"
          size="small"
          fullWidth
          required
          value={active}
          onChange={e => setActive(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          <MenuItem value={true}>
            <Box className={classes.inner}>Yes</Box>
          </MenuItem>
          <MenuItem value={false}>
            <Box className={classes.inner}>No</Box>
          </MenuItem>
        </TextField>

        {/* <div className={`${classes.marginStyle} ${classes.alignCenter}`}>
          <FormControlLabel
            control={<Switch checked={status} onChange={handleSwitch} name="status" color="primary" />}
            label="Status"
            labelPlacement="start"
          />
        </div> */}

        <div className={classes.buttonMarginStyle}>
          {/* {loading ? <LinearProgress /> : null} */}

          <Button
            variant="contained"
            className={classes.buttonStyle}
            color="primary"
            disabled={loading}
            fullWidth
            type="submit">
            {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
            {editForm ? 'Update' : 'Save'}
          </Button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default OptionAddEdit;
